<script lang="ts" setup>
import MenuIcon from "@/components/icons/MenuIcon.vue";
import { defineProps, defineEmits, computed } from "vue";
import CloseIcon from "@/components/icons/CloseIcon.vue";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";
import BlogButton from "@/components/buttons/BlogButton.vue";
import LogoComponent from "@/components/LogoComponent.vue";

const props = defineProps<{
  showBlogBtn: boolean;
  isMenuOpen: boolean;
}>();

defineEmits(["toggleMenu"]);

const menuIcon = computed(() => {
  if (props.isMenuOpen) {
    return CloseIcon;
  }

  return MenuIcon;
});
</script>

<template>
  <aside class="w-full xl:w-[332px] bg-white text-brown flex flex-col z-[100]">
    <div class="flex xl:flex-col xl:h-screen">
      <!-- MOBILE MENU -->
      <div
        class="relative xl:hidden w-14 flex items-center justify-center cursor-pointer bg-active"
        @click="$emit('toggleMenu')"
      >
        <component :is="menuIcon" />
        <div
          v-if="props.isMenuOpen"
          class="flex flex-col absolute left-0 bottom-0 translate-y-full w-screen md:w-[393px] h-[calc(100vh-100%-64px)] bg-white px-4 z-[2000]"
          @click.stop
        >
          <div class="w-full overflow-y-auto no-scrollbar z-[2000]">
            <slot />
          </div>

          <LanguageSwitcher class="w-full flex" />
        </div>
      </div>

      <div
        class="h-14 xl:h-[116px] border-b border-l xl:border-l-0 w-full xl:border-divider pl-2 xl:pl-0 flex justify-between"
      >
        <div class="w-auto md:w-full h-14 xl:h-24 mb-2">
          <LogoComponent />
        </div>
        <BlogButton class="xl:hidden" v-if="props.showBlogBtn" />
      </div>

      <div class="hidden xl:contents">
        <div class="pl-2 overflow-y-auto">
          <slot />
        </div>
      </div>

      <!-- LANG SWITCHER -->
      <LanguageSwitcher class="hidden xl:block mt-auto" />
    </div>
  </aside>
</template>
